import React, { useEffect, useRef, useState } from 'react'
import CreatePurchases from './CreatePurchases'
import Button from '../../components/Button'
import { useNavigate } from 'react-router-dom'
import api, { customFuncsApi, logsUrl } from '../../api'
import { debounce, get } from 'lodash'
import _ from 'lodash'
import Layout from '../../components/Layout'
import { ErrorModal } from '../../components/Modal'
import ClipLoader from 'react-spinners/ClipLoader'
import { isAxiosError } from 'axios'
import moment from 'moment'
import { useSelector } from 'react-redux'
import ConfirmModal from '../../components/ComfirmModal'
import customMainApi from '../../api/index'
import CreateClientOld from '../../components/Modal/CreateClientOld'
import { BG_COLOR } from '../../constants/colors'
import { Select } from 'antd'

const CreatePurchasesPage = () => {
	const { getMe } = useSelector((state) => state.main)

	console.log('getMe', getMe)

	const supplier = get(getMe, 'U_Supplier', '')
	const whs = get(getMe, 'U_Warehouse', '')

	const succesCreateUserRef = useRef()
	const createUserRef = useRef()
	const navigation = useNavigate()
	const errorRef = useRef()
	const inputRef = useRef(null)
	const [businessPartnersData, setBusinessPartnersData] = useState([])
	const [itemsData, setItemsData] = useState([])
	const [selectedItem, setSelectedItem] = useState([])
	const [whichInput, setWhichInput] = useState(null)
	const [loadingBusinessPartners, setLoadingBusinessPartners] = useState(false)
	const [form, setForm] = useState({
		CardCode: get(getMe, 'U_Supplier', ''),
		DocDate: moment().format('YYYY-MM-DD') + 'T00:00:00',
		DocDueDate: '',
		DocCurrency: 'USD',
		DocumentLines: [],
	})
	const [salesPerson, setSalesPerson] = useState([])
	const [slp, setSlp] = useState('')
	const [userFielsds, setUserFields] = useState([])
	const [createUserLoading, setCreateUserLoading] = useState(false)

	const initItem = {
		ItemCode: '',
		Quantity: 0,
		UnitPrice: 0,
		SerialNumbers: '',
		U_Primechaniye: '',
		U_IMEI_PURCH: 'IMEI',
		box: '',
		bateryLife: '',
		shopfrontPrice: '',
		U_Condition: '',
		isNew: false,
		color: '',
		memory: '',
		DocDueDate: '',
	}
	const [items, setItems] = useState([
		{
			...initItem,
		},
	])
	const [itemsName, setItemsName] = useState([''])
	const [showModal, setShowModal] = useState(false)
	const [confirmationMessage, setConfirmationMessage] = useState('')
	const [btnLoading, setBtnLoading] = useState(false)
	const disable = !slp
	const isBtnDisabled =
		items
			.map((item) => {
				return (
					!item.ItemCode ||
					!item.shopfrontPrice ||
					(item.isNew === false && (!item.box || !item.bateryLife)) ||
					disable
				)
			})
			.some((item) => item === true) ||
		!form.CardCode ||
		!form.DocDate ||
		!form.DocDueDate

	const handleOpenModal = () => {
		if (whs === '') {
			errorRef.current?.open(
				get('', 'error.message', 'Ошибка: не выбран склад!'),
			)
			return
		}
		const selectedSlp = salesPerson.find(
			(v) => v.SalesEmployeeCode === Number(slp),
		)
		const uniqueItems = []
		items.forEach((item) => {
			// eslint-disable-next-line no-lone-blocks
			{
				uniqueItems.push({
					ItemCode: item.ItemCode,
					Quantity: 1,
					SerialNumbers: [{ InternalSerialNumber: item.SerialNumbers }],
					UnitPrice: item.UnitPrice,
					U_Primechaniye: item.U_Primechaniye,
					U_IMEI_PURCH: item.U_IMEI_PURCH,
					U_Box: item.box,
					U_Percent: item.bateryLife,
					U_Color: item.color,
					U_Memory: item.memory,
					U_ShopfrontPrice: item.shopfrontPrice,
					// DocDueDate: item.DocDueDate,
				})
			}
		})

		setConfirmationMessage([
			{
				name: 'Дата:',
				value: moment(form.DocDate).format('DD-MM-YYYY'),
			},
			{
				name: 'Дата исполнения:',
				value: moment(form.DocDueDate).format('DD-MM-YYYY'),
			},
			{
				name: 'Менеджер продаж:',
				value: selectedSlp ? selectedSlp.SalesEmployeeName : '',
			},
			{
				name: 'Код клиента :',
				value: form.CardCode,
			},
			{
				name: 'Курс:',
				value: form.DocCurrency,
			},
			...uniqueItems.flatMap((item) => [
				//Bu Valuelar postdigi valuelardan oladi
				{
					name: '--------------------------------------------------------------',
					// value: '',
				},
				{
					name: 'Код товара:',
					value: item.ItemCode,
				},
				// {
				// 	name: 'Дата исполнения:',
				// 	value: `${moment(item.DocDueDate).format('DD-MM-YYYY')}`,
				// },
				{
					name: 'Количество:',
					value: `${item.Quantity}`,
				},
				{
					name: 'Серия номер:',
					value: `${item.SerialNumbers[0].InternalSerialNumber}`,
				},
				{
					name: 'Цена закупки:',
					value: `${item.UnitPrice}`,
				},
				{
					name: 'Цена продажи:',
					value: `${item.U_ShopfrontPrice}`,
				},
				{
					name: 'Коробка:',
					value: `${item.U_Box}`,
				},
				{
					name: 'Ёмкость',
					value: `${item.U_Percent}`,
				},
				{
					name: 'Цвет:',
					value: `${item.U_Color}`,
				},
				{
					name: 'Память:',
					value: `${item.U_Memory}`,
				},

				{
					name: 'Комментарий:',
					value: `${item.U_Primechaniye ? item.U_Primechaniye : 'Нет'}`,
				},
				{
					name: 'IMEI:',
					value: `${item.U_IMEI_PURCH ? item.U_IMEI_PURCH : 'Нет'}`,
				},
			]),
		])
		setShowModal(true)
	}

	const getSalesPersons = () => {
		api
			.get(`SalesPersons?$filter=Active eq 'tYES'`, {
				headers: {
					Prefer: 'odata.maxpagesize=1000000',
				},
			})
			.then((res) => {
				const resData = get(JSON.parse(res.data), 'value', [])
				setSalesPerson(resData)
			})
			.catch((err) => {
				errorRef.current?.open(
					get(
						JSON.parse(err.response.data),
						'error.message',
						'Не удалось получить серийный номер. Повторите попытку.',
					),
				)
			})
	}

	const getBusinessPartners = async (name = '') => {
		// if (name.length <= 0) {
		// 	setBusinessPartnersData([])
		// 	return
		// }
		setLoadingBusinessPartners(true)
		const data = await api(
			`BusinessPartners?$select=CardCode,CardName&$filter=CardType eq 'cSupplier' and Frozen eq 'tNO' and contains(CardName,'${name}') and Frozen eq 'tNO'`,
			{
				headers: {
					Prefer: 'odata.maxpagesize=1000000',
				},
			},
		).then((res) => {
			return JSON.parse(res.data).value
		})

		const selectElementData = data.map((item) => {
			return {
				value: item.CardCode,
				label: `${item.CardName}, ${item.CardCode}`,
			}
		})

		setBusinessPartnersData(selectElementData)
		setLoadingBusinessPartners(false)
	}

	const createUserF = (
		consumer,
		passport,
		male,
		address,
		phone,
		cardCode,
		typeCardCode,
	) => {
		setCreateUserLoading(true)
		api
			.post(`BusinessPartners`, {
				[typeCardCode ? 'CardCode' : 'Series']: cardCode,
				CardName: consumer,
				CardType: 'cSupplier',
				U_Telephone: phone.length ? phone : undefined,
				U_Gender: male,
				U_PS: passport.length ? passport : undefined,
				Currency: '##',
				U_address: address.length ? address : undefined,
			})
			.then(() => {
				createUserRef.current?.close()
				succesCreateUserRef.current?.open('Пользователь успешно создан.')
			})
			.catch((err) => {
				errorRef.current?.open(
					get(
						JSON.parse(err.response.data),
						'error.message',
						'Не удалось получить данные, попробуйте еще раз.',
					),
				)
			})
			.finally(() => {
				setCreateUserLoading(false)
			})
	}

	const purchaseInvoicesPost = async () => {
		const uniqueItems = []
		if (whs === '') {
			alert('Foydalanuvchiga ombor biriktirilmagan')
			return
		}
		items.forEach((item) => {
			// eslint-disable-next-line no-lone-blocks
			{
				uniqueItems.push({
					ItemCode: item.ItemCode,
					Quantity: 1,
					SerialNumbers: [{ InternalSerialNumber: item.SerialNumbers }],
					UnitPrice: parseFloat(item.UnitPrice),
					U_Primechaniye: item.U_Primechaniye,
					U_IMEI_PURCH: item.U_IMEI_PURCH,
					U_Box: item.box,
					U_Percent: item.bateryLife,
					U_ShopfrontPrice: parseFloat(item.shopfrontPrice),
					WarehouseCode: whs,
				})
			}
		})
		const formatedDate = {
			...form,
			SalesPersonCode: Number(slp),
			DocumentLines: uniqueItems,
		}

		setBtnLoading(true)

		console.log(formatedDate)

		try {
			await api
				.post(`PurchaseInvoices`, formatedDate)
				.then((res) => {
					return JSON.parse(res.data).value
				})
				.then((res) => {
					// try {
					// 	logsUrl.post('apis', {
					// 		company_name: COMPANY_NAME,
					// 		method: 'post',
					// 		path: `/PurchaseInvoices`,
					// 		description: 'pokupka yaratish',
					// 		username: `${getMe.FirstName} ${getMe.LastName}, EmployeeID: ${getMe.EmployeeID}`,
					// 		body: JSON.stringify(formatedDate),
					// 	})
					// } catch (err) {
					// 	errorRef.current?.open(
					// 		'Bu jarayon logs tarixiga saqlanmadi. Iltimos bu haqida bizga habar bering!',
					// 	)
					// }
				})
			navigation('/purchases')
		} catch (e) {
			if (isAxiosError(e)) {
				errorRef.current?.open(
					get(JSON.parse(e.response.data), 'error.message', ''),
				)
			}
		} finally {
			setBtnLoading(false)
		}
	}

	const getItems = async (name = '', i) => {
		if (name.length <= 0) {
			setItemsData([])
			return
		}
		setWhichInput(i)
		const data = await api(
			`Items?$select=ItemName,ItemCode,U_Condition&$filter=Frozen eq 'tNO' and contains(ItemName,'${name}')`,
		).then((res) => {
			return JSON.parse(res.data).value
		})

		setItemsData(data)
	}

	const userFieldsFn = () => {
		customMainApi
			.get('UserFieldsMD', {
				params: {
					$filter: "TableName eq 'OITM'",
					$select: 'Name,ValidValuesMD,TableName',
				},
			})
			.then((res) => {
				setUserFields(JSON.parse(res.data).value)
			})
	}

	useEffect(() => {
		getBusinessPartners()
		getSalesPersons()
		userFieldsFn()
	}, [])

	const handleBusinessPartner = _.debounce((e) => {
		getBusinessPartners(e.target.value)
	}, 1000)

	const handleItem = _.debounce((e, i) => {
		getItems(e.target.value, i)
	}, 1000)

	useEffect(() => {
		setForm((prev) => ({ ...prev, DocumentLines: selectedItem }))
	}, [selectedItem])

	const handlePostBtnClick = () => {
		purchaseInvoicesPost()
	}

	const handleStartDateChange = (event, field) => {
		setForm((prev) => ({
			...prev,
			[field]: moment(event.target.value).format('YYYY-MM-DD') + 'T00:00:00',
		}))
	}

	const handleCurrencyChange = (event) => {
		setForm((prev) => ({ ...prev, DocCurrency: event.target.value }))
	}

	const handleBusinessPartnerClick = (event, label, value) => {
		if (inputRef.current) {
			inputRef.current.value = event.target.innerText
		}
		setForm((prev) => ({
			...prev,
			CardCode: value,
		}))
		setBusinessPartnersData([])
	}

	const handleAddItem = () => {
		setItems((prev) => [...prev, { ...initItem }])
		setItemsName((prev) => [...prev, ''])
	}

	const handleRemoveItem = (i) => {
		setItems((prev) => prev.filter((_, idx) => idx !== i))
		setItemsData([])
		setItemsName((prev) => {
			const newItemsName = [...prev]
			newItemsName.splice(i, 1)
			return newItemsName
		})
	}

	const handleClickItem = (code, i) => {
		const condition = itemsData.find((v) => v.ItemCode === code)?.U_Condition
		const price = items.find((v) => v.ItemCode === code)?.UnitPrice
		const isNew = condition === 'NEW'

		setItems((prev) => [
			...prev.map((item, idx) => {
				if (idx === i) {
					return {
						...item,
						ItemCode: code,
						U_Condition: condition,
						UnitPrice: price,
						isNew,
						box: isNew ? '' : item.box,
						bateryLife: isNew ? '' : item.bateryLife,
					}
				}
				return item
			}),
		])
		setItemsName((prev) => {
			const newArray = [...prev]
			newArray[i] = itemsData.find((v) => v.ItemCode === code).ItemName
			return newArray
		})
		setItemsData([])
	}

	const handleTableItemChange = (value, i, field) => {
		setItems((prev) => [
			...prev.map((item, idx) => {
				if (idx === i) {
					return {
						...item,
						[field]: value,
					}
				}
				return item
			}),
		])
	}

	useEffect(() => {
		console.log('items', items)
	}, [items])

	return (
		<Layout>
			<CreatePurchases
				style={{
					backgroundColor: BG_COLOR,
				}}
			>
				<div className="container">
					<div className="flex gap-4 items-start">
						<div className="flex gap-2 items-end">
							<div className="flex flex-col gap-2 items-start w-full">
								<b>Бизнес партнер</b>
								<Select
									className="w-[250px] h-8"
									value={form.CardCode}
									onChange={(val) => {
										setForm((prev) => ({
											...prev,
											CardCode: val,
										}))
									}}
									disabled={disable || supplier}
									showSearch
									filterOption={(input, option) =>
										option.label.toLowerCase().includes(input.toLowerCase())
									}
									options={businessPartnersData}
								/>
							</div>
							<button
								className="bg-[#0A4D68] text-white px-4 rounded-md py-1"
								onClick={() => createUserRef.current?.open()}
							>
								+
							</button>
						</div>

						<div className="flex flex-col gap-2 items-start ">
							<b>Дата документа</b>
							<input
								className={'border-[1px] border-[#DFE2E9"] p-1 rounded-md h-8'}
								type="date"
								value={moment(form.DocDate).format('YYYY-MM-DD')}
								onChange={(e) => handleStartDateChange(e, 'DocDate')}
								disabled={disable}
							/>
						</div>
						<div className="flex flex-col gap-2 items-start ">
							<b>Дата исполнения</b>
							<input
								className={'border-[1px] border-[#DFE2E9"] p-1 rounded-md h-8'}
								type="date"
								value={moment(form.DocDueDate).format('YYYY-MM-DD')}
								onChange={(e) => handleStartDateChange(e, 'DocDueDate')}
								disabled={disable}
							/>
							{!form.DocDueDate && (
								<p className="text-red-500 text-sm w-[250px]">
									Пожалуйста, введите дату исполнения
								</p>
							)}
						</div>

						<div className="flex flex-col gap-2 items-start ">
							<b>Менеджер продаж</b>
							<select
								className={
									'border-[1px] border-[#DFE2E9] p-2 h-8 rounded-md w-full'
								}
								value={slp}
								onChange={(e) => {
									setSlp(e.target.value)
								}}
							>
								<option value="" disabled>
									{'Менеджер продаж'}
								</option>
								{salesPerson
									.filter((v) => v.SalesEmployeeCode !== -1)
									.map((v, i) => (
										<option key={i} value={v.SalesEmployeeCode}>
											{`${v.SalesEmployeeName}`}
										</option>
									))}
							</select>
							{!slp && (
								<p className="text-red-500 text-sm w-[250px]">
									Пожалуйста, выберите Менеджер. Это обязательное поле.
								</p>
							)}
						</div>
						<div className="flex flex-col gap-2 items-start ">
							<b>Валюта</b>
							<Select
								className={'w-[150px] h-8'}
								value={form.DocCurrency}
								onChange={(val) => {
									setForm((prev) => ({
										...prev,
										DocCurrency: val,
									}))
								}}
								disabled={disable}
							>
								<Select.Option>USD</Select.Option>
							</Select>
						</div>
					</div>
					<div className="overflow-y-auto my-8">
						<table className="w-full text-sm text-left rtl:text-right text-gray-500 ">
							<thead className="text-xs text-gray-700 uppercase bg-gray-50 "></thead>
							<tbody>
								{items.map((v, i) => {
									return (
										<tr className="bg-white  hover:bg-gray-50 " key={i}>
											<td className="px-6 py-4 border">
												<div className="flex gap-2 flex-col items-start">
													<span className="text-gray-500">
														Наименование товара
													</span>
													<div className="searchable-select">
														<div className={'searchableHead'}>
															<div>
																<input
																	className={
																		'border-[1px] border-[#DFE2E9"] p-1 rounded-md'
																	}
																	type="text"
																	onChange={(event) => {
																		const val = event.target.value

																		handleItem(event, i)
																		setItemsName((prev) => {
																			const newArray = [...prev]
																			newArray[i] = val
																			return newArray
																		})
																		if (val === '') {
																			const newItems = [...items]
																			newItems[i].ItemCode = ''
																			newItems[i].U_Condition = ''
																			setItems(newItems)
																		}
																	}}
																	placeholder="Наименование товара"
																	value={itemsName[i]}
																	disabled={disable}
																/>
																{!!itemsData.length && i === whichInput && (
																	<div className="searchable-select-list">
																		{itemsData.map((item) => {
																			return (
																				<div
																					onClick={() =>
																						handleClickItem(item.ItemCode, i)
																					}
																					key={item.ItemCode}
																					className="searchable-select-item"
																				>
																					{item.ItemName}
																				</div>
																			)
																		})}
																	</div>
																)}
															</div>
														</div>
													</div>
												</div>
											</td>
											{/* <td className="px-6 py-4 border">
												<div className="flex gap-2 flex-col items-start">
													<span className="text-gray-500">Дата исполнения</span>
													<input
														type="date"
														className={
															'border-[1px] border-[#DFE2E9"] p-1 rounded-md cursor-not-allowed'
														}
														value={v.DocDueDate}
														onChange={(event) => {
															handleTableItemChange(
																event.target.value,
																i,
																'DocDueDate',
															)
														}}
														disabled={disable}
													/>
													{!disable && v.ItemCode && v.DocDueDate === '' && (
														<span className="text-red-600">
															Поле обязательно
														</span>
													)}
												</div>
											</td> */}
											<td className="px-6 py-4 border">
												<div className="flex gap-2 flex-col items-start">
													<span className="text-gray-500">Состояние</span>
													<input
														disabled={true}
														className={
															'border-[1px] border-[#DFE2E9"] p-1 rounded-md cursor-not-allowed'
														}
														value={v.U_Condition}
													/>
												</div>
											</td>
											<td className="px-6 border py-4">
												<div className="flex gap-2 flex-col items-start">
													<span className="text-gray-500">С имеи</span>
													<select
														className={
															'border-[1px] border-[#DFE2E9"] p-1 rounded-md'
														}
														onChange={(event) =>
															handleTableItemChange(
																event.target.value,
																i,
																'U_IMEI_PURCH',
															)
														}
														value={v.U_IMEI_PURCH}
														disabled={disable}
													>
														<option value="IMEI">С имеи</option>
														<option value="bez">Без</option>
													</select>
												</div>
											</td>
											<td className="px-6 border py-4">
												<div className="flex gap-2 flex-col items-start">
													<span className="text-gray-500">ИМЕИ</span>
													<input
														placeholder="ИМЕИ"
														className={
															'border-[1px] border-[#DFE2E9"] p-1 rounded-md'
														}
														value={v.SerialNumbers}
														onChange={(e) => {
															handleTableItemChange(
																e.target.value,
																i,
																'SerialNumbers',
															)
														}}
														disabled={disable}
													/>
												</div>
											</td>
											<td className="px-6 border py-4">
												<div className="flex gap-2 flex-col items-start">
													<span className="text-gray-500">Коробка</span>
													<select
														name="Коробка"
														className={`border-[1px] border-[#DFE2E9"] p-1 rounded-md w-[200px] ${v.isNew && 'bg-gray-100'}`}
														value={v.box}
														onChange={(e) => {
															handleTableItemChange(e.target.value, i, 'box')
														}}
														disabled={disable || v.isNew}
													>
														<option value="" disabled></option>
														<option value="Bor">Bor</option>
														<option value="Yo'q">Yo'q</option>
													</select>
													{!disable &&
														!v.isNew &&
														v.ItemCode &&
														v.box === '' && (
															<span className="text-red-600">
																Поле обязательно
															</span>
														)}
												</div>
											</td>
											<td className="px-6 border py-4">
												<div className="flex gap-2 flex-col items-start">
													<span className="text-gray-500">Цвет</span>
													<input
														placeholder="Цвет"
														className={
															'border-[1px] border-[#DFE2E9"] p-1 rounded-md'
														}
														value={v.color}
														onChange={(e) => {
															handleTableItemChange(e.target.value, i, 'color')
														}}
														disabled={disable}
													/>
												</div>
											</td>
											<td className="px-6 border py-4">
												<div className="flex gap-2 flex-col items-start">
													<span className="text-gray-500">Память</span>
													<input
														placeholder="Память"
														className={
															'border-[1px] border-[#DFE2E9"] p-1 rounded-md'
														}
														value={v.memory}
														onChange={(e) => {
															handleTableItemChange(e.target.value, i, 'memory')
														}}
														disabled={disable}
													/>
												</div>
											</td>

											<td className="px-6 border py-4">
												<div className="flex gap-2 flex-col items-start">
													<span className="text-gray-500">Ёмкость</span>
													<input
														placeholder="Ёмкость"
														className={
															'border-[1px] border-[#DFE2E9"] p-1 rounded-md'
														}
														value={v.bateryLife}
														onChange={(e) => {
															handleTableItemChange(
																e.target.value,
																i,
																'bateryLife',
															)
														}}
														disabled={disable || v.isNew}
													/>
													{!disable &&
														!v.isNew &&
														v.ItemCode &&
														v.bateryLife === '' && (
															<span className="text-red-600">
																Поле обязательно
															</span>
														)}
												</div>
											</td>
											<td className="px-6 border py-4">
												<div className="flex gap-2 flex-col items-start">
													<span className="text-gray-500">Комментарий</span>
													<input
														placeholder="Комментарий"
														className={
															'border-[1px] border-[#DFE2E9"] p-1 rounded-md'
														}
														value={v.U_Primechaniye}
														onChange={(e) => {
															handleTableItemChange(
																e.target.value,
																i,
																'U_Primechaniye',
															)
														}}
														disabled={disable}
													/>
												</div>
											</td>
											<td className="px-6 border py-4">
												<div className="flex gap-2 flex-col items-start">
													<span className="text-gray-500">Цена закупки</span>
													<input
														className={
															'border-[1px] border-[#DFE2E9"] p-1 rounded-md'
														}
														type="text"
														placeholder="Цена закупки"
														onChange={(e) => {
															handleTableItemChange(
																e.target.value,
																i,
																'UnitPrice',
															)
														}}
														disabled={disable}
														value={v.UnitPrice}
													/>
												</div>
											</td>
											<td className="px-6 border py-4">
												<div className="flex gap-2 flex-col items-start">
													<span className="text-gray-500">Цена продажи</span>
													<input
														placeholder="Цена продажи"
														className={
															'border-[1px] border-[#DFE2E9"] p-1 rounded-md'
														}
														value={v.shopfrontPrice}
														onChange={(e) => {
															handleTableItemChange(
																e.target.value,
																i,
																'shopfrontPrice',
															)
														}}
														disabled={disable}
													/>
													{!disable &&
														v.ItemCode &&
														v.shopfrontPrice === '' && (
															<span className="text-red-600">
																Поле обязательно
															</span>
														)}
												</div>
											</td>
											{i === items.length - 1 ? (
												<button
													onClick={handleAddItem}
													className="p-4 bg-[#0A4D68] mt-5 text-white rounded-md ml-2"
												>
													+
												</button>
											) : null}
											{items.length > 1 ? (
												<button
													onClick={() => handleRemoveItem(i)}
													className="p-4 bg-red-600 mt-5 text-white rounded-md ml-2"
												>
													-
												</button>
											) : null}
										</tr>
									)
								})}
							</tbody>
						</table>
					</div>

					<div
						style={{
							display: 'flex',
							justifyContent: 'end',
							paddingRight: '50px',
							paddingTop: '30px',
						}}
					>
						<Button
							isLoading={btnLoading}
							onClick={handleOpenModal}
							disabled={isBtnDisabled}
						>
							Создать
						</Button>
					</div>
				</div>
			</CreatePurchases>
			<>
				<CreateClientOld
					isLoading={createUserLoading}
					getRef={(r) => (createUserRef.current = r)}
					onConfirm={(
						consumer,
						passport,
						male,
						address,
						phone,
						cardCode,
						typeCardCode,
					) =>
						createUserF(
							consumer,
							passport,
							male,
							address,
							phone,
							cardCode,
							typeCardCode,
						)
					}
				/>
				<ErrorModal
					getRef={(r) => {
						errorRef.current = r
					}}
				/>
			</>
			<ConfirmModal
				show={showModal}
				data={confirmationMessage}
				onConfirm={() => {
					setShowModal(false)
					handlePostBtnClick()
				}}
				onCancel={() => {
					setShowModal(false)
				}}
			/>
		</Layout>
	)
}

export default CreatePurchasesPage
